import { UserSettings } from "@/config";
import { NicknameRegex } from "@/services/validators";
import { z } from "zod";

export const Nickname_Schema = z.string().min(UserSettings.nicknameMinLength).max(UserSettings.nicknameMaxLength).regex(NicknameRegex);
